import toWebpImage from '@src/utils/to-webp-image';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const pageLocalesData = getPageLocalesData();
const LocalesData = pageLocalesData.mechaUnit;
const triceraData = LocalesData.tricera;
const lang = getLanguageByPath();

/**
 *  特装机甲数据
 */
export const mechaData = {
  mechaName: toWebpImage(`${require('./images/' + lang + '/warrior-name.png')}`),
  mechaImg: toWebpImage(require('./images/structure.png')),
  driverImg: toWebpImage(require('./images/per.png')),
  iconBadge: toWebpImage(require('./images/icon-badge.png')),
  maLogo: toWebpImage(require('./images/ma-logo.png')),
  btnBack: toWebpImage(require('./images/' + lang + '/btn-back.png')),
  driverStoryTitle: require('./images/' + lang + '/driver-story-title.png'),
  cvTab: [toWebpImage(require('./images/checked1.png')), toWebpImage(require('./images/checked2.png')), toWebpImage(require('./images/checked3.png'))],
  audioScreen: require('./images/audio-screen.png'),
  mechaInfoTitle: require('./images/' + lang + '/mecha-info-title.png'),
  manufacturerTitle: require('./images/' + lang + '/manufacturer-title.png'),
  basicInfoTitle: LocalesData.basicInfoTitle,
  driverVoiceTitle: LocalesData.driverVoiceTitle,
  mechaStorySubTitle: LocalesData.mechaStorySubTitle,
  roleExperSubTitle: LocalesData.roleExperSubTitle,
  driverName: triceraData.driverName,
  driverType: triceraData.driverType,
  driversSex: triceraData.driversSex,
  driversBirthplace: triceraData.driversBirthplace,
  driversStructure: triceraData.driversStructure,
  driversRoleExperText: triceraData.driversRoleExperText,
  mechaInfoType: triceraData.mechaInfoType,
  mechaInfoNums: triceraData.mechaInfoNums,
  mechaInfoHeadHigh: triceraData.mechaInfoHeadHigh,
  mechaInfoEmptyWeight: triceraData.mechaInfoEmptyWeight,
  mechaInfoTotal: triceraData.mechaInfoTotal,
  mechaInfoStory: triceraData.mechaInfoStory,
  manufacturerGruopCh: triceraData.manufacturerGruopCh,
  cvCH: triceraData.cvCH,
  cvEN: triceraData.cvEN,
  cvJA: triceraData.cvJA,
  zhCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512810109_1CN-Vox_Pilot_Get_Elite_CharlesBell.wav',
      title: triceraData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512810109_2CN-Vox_Pilot_Entrance_Elite_CharlesBell_a.wav',
      title: triceraData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512810109_3CN-Vox_Pilot_MVP_Elite_CharlesBell_c.wav',
      title: triceraData.voice.title3,
      isPlay: false
    }
  ],
  enCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512842288_1EN-Vox_Pilot_Get_Elite_CharlesBell.wav',
      title: triceraData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512842288_2EN-Vox_Pilot_Entrance_Elite_CharlesBell_a.wav',
      title: triceraData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512842288_3EN-Vox_Pilot_MVP_Elite_CharlesBell_c.wav',
      title: triceraData.voice.title3,
      isPlay: false
    }
  ],
  jaCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512872565_1JP-Vox_Pilot_Get_Elite_CharlesBell.wav',
      title: triceraData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512872565_2JP-Vox_Pilot_Entrance_Elite_CharlesBell_a.wav',
      title: triceraData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512872565_3JP-Vox_Pilot_MVP_Elite_CharlesBell_c.wav',
      title: triceraData.voice.title3,
      isPlay: false
    }
  ]
};
